module.exports = __webpack_public_path__ + "static/media/copy.00d47037.png";